import * as React from 'react'
import { compose } from 'redux'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { reduxForm, Field } from 'redux-form'
import Table from '@App/components/blocks/Table'
// @ts-ignore
import {
  ToggleSwitch,
  // @ts-ignore
} from 'relevant-ui'

import './styles.scss'
import '../form.scss'
import { Fields, DispatchProps, Props, State } from './types'
import InputField from '@App/components/fields/InputField'
import ButtonWrapper from '@App/components/blocks/UiPage/Button'
import Modal from '@App/components/blocks/Modal'
import {
  ModalType,
  ModalSize,
  setShowModal,
  setHideModal,
} from '@App/store/modal'
import NewSegmentForm from '../NewSegmentForm'
import FormatText from '@App/helpers/formatText'

class AppForm extends React.Component<Props, State> {
  static renderTableCell(item: any) {
    return {
      id: item.id,
      name: { title: item.name, subtitle: `role: ${item.minimumRoleValue}` },
      label: { title: item.label },
    }
  }

  static defaultProps = {
    header: [
      { name: 'name', alias: 'name', sortable: false },
      { name: 'label', alias: 'label', sortable: false },
      { name: '', alias: 'action', small: false },
    ],
    body: [{ name: 'name' }, { name: 'label' }, { name: 'action' }],
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      toggleElements: [],
      tableList: [],
      editSegment: null,
    }
    this.setDefaultValue = this.setDefaultValue.bind(this)
    this.handleSemgent = this.handleSemgent.bind(this)
    this.handleDeleteSegment = this.handleDeleteSegment.bind(this)
    this.setEditSegment = this.setEditSegment.bind(this)
  }

  componentDidMount() {
    if (this.props.current) {
      this.setState({
        toggleElements: this.props.current.segments,
        tableList: this.props.current.segments,
      })
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { current } = this.props
    const { current: prevCurrent } = prevProps

    if (current !== prevCurrent) {
      return this.setState({
        tableList: current?.segments || [],
      })
    }
  }

  setDefaultValue(id) {
    const { current } = this.props
    if (current?.segments?.find((el: any) => el.id === id)) return true
    return false
  }

  handleToggle(elmt: any, active: boolean) {
    if (!active) {
      this.setState({
        toggleElements: this.state.toggleElements?.filter(
          (el: any) => el.value !== elmt.value,
        ),
      })

      return
    }

    this.setState({
      toggleElements: this.state.toggleElements.concat(elmt),
    })

    return
  }

  handleSemgent(e, data, id?) {
    const { tableList, editSegment } = this.state
    e.preventDefault()

    if (editSegment) {
      this.setState({
        tableList: [...tableList?.filter((el: any) => el.id !== id), data],
        editSegment: null,
      })
      return this.props.setHideModal()
    }

    this.setState({ tableList: [...tableList, data] })
    return this.props.setHideModal()
  }

  handleDeleteSegment(id, row) {
    this.setState({
      tableList: this.state.tableList?.filter((el: any) => el.name !== row.name),
    })
  }

  setEditSegment(id, row) {
    this.setState({ editSegment: row })
    this.props.setShowModal(ModalType.FORM)
  }
  render() {
    const {
      t,
      toggle,
      handleCancel,
      handleSubmit,
      header,
      body,
      setShowModal,
      setHideModal,
      handleDelete,
    } = this.props

    const { tableList } = this.state

    const segmentList =
      tableList?.map((item: any) => {
        return {
          ...item,
          data: AppForm.renderTableCell(item),
        }
      }) || []

    return (
      <form className="form form__connect">
        <div className="form__wrapper">
          <section className="formWrapper">
            <h4 className="formWrapper__title">{t('informations')}</h4>
            <div className="formWrapper__fields">
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('Name')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.NAME}
                    component={InputField}
                    label="Name"
                    placeholder="Name..."
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('label')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.LABEL}
                    component={InputField}
                    label="Label"
                    placeholder="Label..."
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--large">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('url')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.URL}
                    component={InputField}
                    label="Url"
                    placeholder="Url..."
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="formWrapper formWrapper--noBorder">
            <h4 className="formWrapper__title mb-20">{t('segment')}</h4>
            <div
              className={classnames(
                'formWrapper__container',
                toggle && 'desabled',
              )}
            >
              <Table
                disableTopBorder
                header={header}
                body={body}
                data={segmentList || []}
                deleteRow={this.handleDeleteSegment}
                editRow={this.setEditSegment}
                hideNoData
              />
              <div
                className="formWrapper__newSegment"
                onClick={() => {
                  setShowModal(ModalType.FORM)
                }}
              >
                <div className="formWrapper__text">
                  <span className="more">+</span>
                  <span className="link">{t('add_segment')}</span>
                </div>
              </div>
            </div>
          </section>
        </div>
        <ButtonWrapper
          onCancel={handleCancel}
          dataTable={this.state.tableList}
          onSubmit={handleSubmit}
          onDelete={handleDelete}
        />
        <Modal
          type={ModalType.FORM}
          size={ModalSize.FIT}
          handleClose={() => { }}
        >
          <NewSegmentForm
            onSubmit={(e, data, id) => this.handleSemgent(e, data, id)}
            canceled={() => {
              this.setState({ editSegment: null }), setHideModal()
            }}
            editSegment={this.state.editSegment}
          />
        </Modal>
      </form>
    )
  }
}

const validate = (values) => {
  const regexUrl = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi

  const errors = {}

  if (!values[Fields.NAME]) {
    errors[Fields.NAME] = 'Required'
  }
  if (!values[Fields.LABEL]) {
    errors[Fields.LABEL] = 'Required'
  }
  if (!values[Fields.URL] && !regexUrl.test(values[Fields.URL])) {
    errors[Fields.URL] = 'Required'
  }

  return errors
}

const NewAppForm = reduxForm({
  validate,
  form: Fields.FORM,
  enableReinitialize: true,
})(AppForm as any)

const mapStateToProps = (state: any) => {
  const {
    toggleFields: { toggle },
    applications: { current },
    segments: { list: segmentList },
  } = state

  let initialValues = {}

  if (current) {
    initialValues = {
      [Fields.NAME]: current.title || '',
      [Fields.LABEL]: current.subtitle || '',
      [Fields.URL]: current.url || '',
    }
  }

  return {
    current,
    toggle,
    initialValues,
    segmentList,
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    setShowModal: (type: any) => dispatch(setShowModal(type)),
    setHideModal: () => dispatch(setHideModal()),
  }
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(NewAppForm)
